import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import TipoEntidadeIntegracao from "@/models/enum/tipoEntidadeIntegracao";
import IntegracaoSeniorErrosModel from "@/models/IntegracaoSeniorErrosModel";
import PaginationModel from "@/models/paginationModel";
import integracaoSeniorErrosService from "@/services/integracaoSenior/integracaoSeniorErrosService";

import ListComponentBase from "../crud/listComponentBase";

@Component
export default class IntegracaoSeniorErrosListComponent extends ListComponentBase<IntegracaoSeniorErrosModel> {
    isHidden = false;
    extraActions: Array<object> = [];
    gridExtraActionsRedicionar: Array<GridAction> = [];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricaoErro", "Descrição", GridColumnType.String),
            new GridColumn("entidadeIntegracaoDescricao", "Entidade Integracao", GridColumnType.String),
            new GridColumn("dataCriacao", "Data", GridColumnType.Date),
        ];
    }

    public async afterLoad() {
        this.extraActions.splice(0);
        this.gridExtraActionsRedicionar.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            this.gridExtraActionsRedicionar.push(
                new GridAction("redicionar", "Redicionar.", "fa fa-edit", GridColors.BLUE),
            );
        }

        this.extraActions.push(this.gridExtraActionsRedicionar);
    }

    public async loadMethod() {
        return await integracaoSeniorErrosService
            .list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<IntegracaoSeniorErrosModel>>();
    }

    private onExtraAction(name: string, model: IntegracaoSeniorErrosModel) {
        if (name.trim() == "redicionar") {
            this.onRedicionar(model.registroId, model.entidadeIntegracao);
        }
    }

    public async onRedicionar(registroId: number, entidadeIntegracao: TipoEntidadeIntegracao) {
        switch (entidadeIntegracao) {
            case TipoEntidadeIntegracao.Cliente:
                this.$router.push("/cliente-edicao/" + registroId);
                break;
            case TipoEntidadeIntegracao.Fornecedor:
                this.$router.push("/fornecedor-edicao/" + registroId);
                break;
            case TipoEntidadeIntegracao.Servico:
                this.$router.push("/servico-edicao/" + registroId);
                break;
        }
    }

    private beforeMount() {
        this.setProps(null, "integracaoSeniorErros", "descricaoErro");
    }
}
